const subscribeMembershipPackageToast = (state = null, action) => {
  if (action.type === "SET_SUBSCRIBE_MEMBERSHIP_PACKAGE_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_SUBSCRIBE_MEMBERSHIP_PACKAGE_TOAST": {
  //     return action.payload;
  //   }
  
  //   default: {
  //     return state;
  //   }
  // }
};

export default subscribeMembershipPackageToast;
